// extracted by mini-css-extract-plugin
export var card = "_n4-0";
export var content = "_n4-2";
export var details = "_n4-3";
export var icon = "_n4-1";
export var iconBlue = "_n4-5";
export var iconBrand = "_n4-4";
export var iconGrayBlue = "_n4-6";
export var iconGreen = "_n4-7";
export var iconIndigo = "_n4-8";
export var iconOrange = "_n4-9";
export var iconPurple = "_n4-a";
export var iconRed = "_n4-b";
export var iconWarning = "_n4-c";